import { K9 } from "../k9_data";
import { JdPokerComponent } from "../../../../jd/module/table/component/jd_poker_component";
import { K9HoldSprite } from "./k9_hold_sprite";
import CustomUIStateSwitcher from "../../../../public/ui/custom_ui_state_switcher";
import Utility from "../../../../../utility/utility";
import { PokerCommonColor } from "./poker_com_color";

const {ccclass, property} = cc._decorator;

//处理亮牌
@ccclass
export default class K9ShowPoker extends cc.Component {

    @property([cc.Animation])
    animation:cc.Animation[] = [];

    @property([cc.Node])
    nodes:cc.Node[]=[];

    @property(cc.Node)
    pattern:cc.Node[] = [];

    @property([PokerCommonColor])
    pokers2:PokerCommonColor[] = [];

    @property([PokerCommonColor])
    pokers3:PokerCommonColor[] = [];

    @property([cc.Sprite])
    patternSprite:cc.Sprite[] = [];

    @property(K9HoldSprite)
    k9sprite:K9HoldSprite = null;

    @property([cc.Sprite])
    normalBeiShu:cc.Sprite[] = [];//普通倍数

    @property(cc.Sprite)
    teshuBeiShu:cc.Sprite = null;//特殊牌型倍数

    @property(CustomUIStateSwitcher)
    customSwitcher:CustomUIStateSwitcher = null;

    onShow(data:K9.SeatData){
        if (!data) {
            return;
        }
        this.onReset();
        //设置牌值
        //1.2张 2.3张
        this.setCards(data.cards);
        //展示牌动画
        let index = data.cards.length == 2 ? 0 : 1
        this.nodes[index].active = true;
        this.playAnim(index);
        //牌型显示
        if (data.card_type == K9.CardType.Single) {//普通牌型
            this.pattern[0].active = true;
            this.patternSprite[0].spriteFrame =  this.k9sprite.getSpriteFrameByName(data.card_point.toString())
            this.changePatternType(data.cards,true);
            if (this.isTeShuPaiXing(data.win_rate)) {
                let str = 'normal_' + data.win_rate;
                this.normalBeiShu[data.cards.length-2].node.active = true;
                this.normalBeiShu[data.cards.length-2].spriteFrame = this.k9sprite.getSpriteFrameByName(str);
            }
        }else if(data.card_type == K9.CardType.K8
        || data.card_type == K9.CardType.K9){

        }else{//特殊牌型
            this.changePatternType(data.cards,false);
            this.nodes[2].active = true;
            this.playAnim(2);
            this.patternSprite[1].spriteFrame = this.k9sprite.getSpriteFrameByName(K9.PokerDes[data.card_type]);
            this.patternSprite[2].spriteFrame = this.k9sprite.getSpriteFrameByName(K9.PokerDes[data.card_type]);
            if (this.isTeShuPaiXing(data.win_rate)) {
                this.teshuBeiShu.node.active = true;
                this.teshuBeiShu.spriteFrame = this.k9sprite.getSpriteFrameByName('per_' + data.win_rate);
            }
        }
    }

    grayNode(data:K9.SeatData,isGray:boolean){
        if (!isGray) {
            Utility.setNodeGray(this.nodes[2],false);
            Utility.setNodeGray(this.pattern[0],false);
            return;
        }

        if (!data) {
            return;
        }
        if (data.card_type == K9.CardType.Single) {
            Utility.setNodeGray(this.pattern[0],true);
        }else if(data.card_type == K9.CardType.K8
            || data.card_type == K9.CardType.K9){
    
        }else{
            Utility.setNodeGray(this.nodes[0],true);
        }
    }

    //是否是特殊牌型
    isTeShuPaiXing(rate:number){
        return rate == 2 || rate == 3 || rate == 5;
    }

    //更改牌型样式
    changePatternType(cards:number[],isNormal:boolean){
        let str = '';
        if (cards.length == 2) {//
            str = isNormal ? 'k9kaipai2_normal':'k9kaipai2_normal';
        }else{
            str = isNormal ? 'k9kaipai3_normal':'k9kaipai3_ts'
        }
        this.customSwitcher.SwitchState(str);
    }

    setCards(cards:number[]){
        if (cards.length == 2) {
            for (let i = 0; i < 2; i++) {
                this.pokers2[i].code = cards[i];
                this.pokers2[i].showCardOnly();
            }
        }else if (cards.length == 3) {
            for (let i = 0; i < 3; i++) {
                this.pokers3[i].code = cards[i];
                this.pokers3[i].showCardOnly();
            }
        }
    }

    playAnim(index:number){
        let anim = this.animation[index];
        if (anim && anim.node.active) {
            anim.play();
        }
    }

    onReset(){
        for (let node of this.nodes) {
            node.active = false;
        }
        for (let pattern of this.pattern) {
            pattern.active = false;
        }
        for (let beishu of this.normalBeiShu) {
            beishu.node.active = false;
        }
        this.teshuBeiShu.node.active = false;
        this.customSwitcher.SwitchState('none')
    }
}
